import { useTranslation as e } from "../../i18n.mjs";
import { isImageSelected as t } from "../image-extension/utils/is-image-selected.mjs";
import { toolbarActionItem as n } from "../../components/content-controls/toolbar-action-item.mjs";
import { LinkBubbleMenu as r } from "./link-bubble-menu.mjs";
import { useUpdateLinkColor as i } from "./use-update-link-color.mjs";
import { FileSourceEnum as a } from "@systemeio/file-manager";
import { useEditorState as o } from "@tiptap/react";
import { useMemo as s } from "react";
import { jsx as c } from "react/jsx-runtime";
import { Link03Icon as l } from "@systemeio/icons";
//#region src/extensions/link-extension/use-link-extension-toolbar.tsx
var u = (u, d) => {
	let f = d?.color, p = d?.fileSource ?? a.TextEditor, { t: m } = e(), h = o({
		editor: u,
		selector: ({ editor: e }) => ({
			isEditable: e?.options.editable ?? !1,
			isActive: e?.isActive("link"),
			isImageSelected: t(e)
		})
	}), g = h?.isActive ?? !1, _ = !h?.isEditable || !!h?.isImageSelected;
	return i(u, f), s(() => ({
		...n({
			active: g,
			disabled: _,
			icon: /* @__PURE__ */ c(l, {}),
			label: m("link"),
			onClick: () => {
				if (!u) return null;
				u.isActive("link") ? u.chain().focus() : u.chain().focus().extendMarkRange("link").setLink({ href: "" }).updateAttributes("link", { color: f }).run();
			}
		}),
		additionalRender: /* @__PURE__ */ c(r, {
			editor: u,
			fileSource: p,
			options: d
		})
	}), [
		_,
		m,
		g,
		u,
		p,
		f,
		d
	]);
};
//#endregion
export { u as useLinkExtensionToolbar };
